export default "__VITE_ASSET__25defa0c__"